/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import {
  CssBaseline,
  makeStyles,
  Container,
  ThemeProvider,
  useMediaQuery
} from '@material-ui/core'
import theme from './utils/customTheme'
import Constants from './utils/Constants'

//Components
import Navbar from './components/Navbar'
import Sidebar from './components/Sidebar'

//IMG
import banner from './img/medical.png'

const useStyles = makeStyles({
  main_mobile:{
    display: 'flex',
    justifyContent: 'center',
    marginTop: '100px'
  },
  main_desktop:{
    width: `calc(100% - ${Constants.sideBarWidth})`,
    marginLeft: Constants.sideBarWidth,
    display: 'flex',
    justifyContent: 'center',
    marginTop: '100px'
  }
});

export default function App(props) {
  const classes = useStyles();
  const [sideBar, setSideBar] = useState(false)
  const mobileMatches = useMediaQuery('(max-width:780px)');

  const openSideBar = () => {
    setSideBar(true)
  }

  const closeSideBar = () => {
    setSideBar(false)
  }
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navbar openSideBar={openSideBar} mobile={mobileMatches}/>
      <Sidebar open={sideBar} closeSideBar={closeSideBar} mobile={mobileMatches} />
      <main>
        <Container className={mobileMatches ? classes.main_mobile : classes.main_desktop}>
          {props.component ? props.component : (<img src={banner} style={{maxWidth: '70%',height: 'auto'}} />)}
        </Container>
      </main>
    </ThemeProvider>
  );
}